import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] App crashed:', error.message);
    console.error(info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return React.createElement('div', { style: { padding: 40, fontFamily: 'monospace' } },
        React.createElement('h2', { style: { color: '#D00000' } }, 'App crashed — see browser console (F12) for the error'),
        React.createElement('pre', {
          style: { background: '#f5f5f5', padding: 16, borderRadius: 8, overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }
        }, String(this.state.error?.message || '') + '\n\n' + String(this.state.error?.stack || '')),
        React.createElement('button', {
          onClick: () => window.location.href = '/login',
          style: { marginTop: 16, padding: '8px 24px', cursor: 'pointer', background: '#000040', color: '#fff', border: 'none', borderRadius: 6 }
        }, 'Go to /login')
      );
    }
    return this.props.children;
  }
}
